/*
 * @Author: your name
 * @Date: 2021-07-13 14:49:11
 * @LastEditTime: 2023-10-17 10:40:42
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\router\center-setting\index.js
 */
import user from './user'; // 用户
import goods from './goods'; // 商品
import baseData from './base-data'; // 基础数据
import indexes from './indexes'; // 索引配置
// import file from './file'; // 文件管理
import instance from './instance'; // 事务管理
import label from './label'; // 标签管理
import Import from './import'; // 导入管理

// #ifndef OPEN-SOURCE
import stock from './stock'; // 库存
import logistics from './logistics'; // 物流
import order from './order'; // 订单
// import finance from './finance'; // 财务
// import bpmn from './bpmn'; // bpmn 工作流
// import test from './test'; // bpmn 工作流
import tenant from './tenant'; // 租户
// #endif

/* ******************************  暂时不显示  *******************************/
// import message from './message'; // 消息服务
// import after from './after'; // 售后
// import scheduler from './scheduler'; // 调度服务

// 修改以下数组，需同时修改 src\layout\components\Sidebar\HoverItem.vue 99:TODO
const SETTING_CENTER_ROUTER = [
  user,
  goods,
  // #ifndef OPEN-SOURCE
  stock,
  // #endif
  // #ifndef OPEN-SOURCE
  logistics,
  // #endif
  // #ifndef OPEN-SOURCE
  order,
  // #endif
  // after
  // #ifndef OPEN-SOURCE
  // finance,
  // #endif

  baseData,
  // message,
  indexes,

  // file,
  // scheduler,
  instance,
  label,
  Import,
  // #ifndef OPEN-SOURCE
  // bpmn,
  // test,
  tenant
  // #endif
  // manage,
  // processOrder,
  // stockStructure,
  // processChecking,
  // search,

  // statement,
];

// 按可见子菜单数量 从小到大 排序一下……
// SETTING_CENTER_ROUTER.sort(function(a, b) {
//   return (
//     a.children.filter(e => e.hidden != true).length -
//     b.children.filter(e => e.hidden != true).length
//   );
// });

export default SETTING_CENTER_ROUTER;
